import { useEffect, useState } from 'react';
import { toAbsoluteUrl } from '../../../assets/helpers/AssetHelpers';
import './style.css';
import useWindowSize from './useWindowSize';
import { useHeaderSearch } from './useHeaderSearch';
import { NavbarOffcanvasMenu } from './NavbarOffcanvasMenu';
import { NavCtaLinks } from './NavCtaLinks';

const Navbar = () => {
	const { width } = useWindowSize();
	const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
	const { isMobileSearchOpen, openMobileSearch, closeMobileSearch, renderSearchForm } = useHeaderSearch();

	useEffect(() => {
		const offcanvasEl = document.getElementById('offcanvasExample');
		if (!offcanvasEl) {
			return;
		}
		const handleShow = () => setIsOffcanvasOpen(true);
		const handleHide = () => setIsOffcanvasOpen(false);
		offcanvasEl.addEventListener('show.bs.offcanvas', handleShow);
		offcanvasEl.addEventListener('hidden.bs.offcanvas', handleHide);
		return () => {
			offcanvasEl.removeEventListener('show.bs.offcanvas', handleShow);
			offcanvasEl.removeEventListener('hidden.bs.offcanvas', handleHide);
		};
	}, []);

	const isSmOnlyDevice = (width ?? 0) >= 0 && (width ?? 0) < 576;
	const isMdToLgDevice = (width ?? 0) >= 576 && (width ?? 0) < 1200;
	const isXlDevice = (width ?? 0) >= 1200;

	return (
		<>
			<section id="nav-section">
				<div className="container">
					<div className="row">
						<div className="col">
							<div className="row">
								<div className="col-lg-11 mx-auto px-4 px-md-5 px-lg-1">
									<nav className="navbar navbar-expand-xl py-1">
										<div className="container p-0 position-relative">
											{isSmOnlyDevice && isMobileSearchOpen && (
												<div className="header-search-takeover d-flex align-items-center">
													{renderSearchForm('header-search-form flex-grow-1')}
													<button
														type="button"
														className="btn-close ms-3"
														aria-label="Close search"
														onClick={closeMobileSearch}></button>
												</div>
											)}
											<a className="navbar-brand navbar_brand me-0" href={process.env.REACT_APP_MAIN_WEBSITE_URL}>
												<img
													className="mobile-logo-jainam"
													src={toAbsoluteUrl('navbar-section/jainam.webp')}
													alt="jainam"
													width={150}
												/>
											</a>
											<div className="d-flex align-items-center">
												{isSmOnlyDevice && (
													<div className="">
														<button
															type="button"
															className="header-search-icon-btn"
															aria-label="Search"
															onClick={openMobileSearch}>
															<img src={toAbsoluteUrl('header-images/search.svg')} alt="" />
														</button>
													</div>
												)}
												{isMdToLgDevice && (
													<div className="me-3 flex-grow-1">{renderSearchForm('header-search-form')}</div>
												)}
												<button
													className={`btn btn_outline hamburger-btn d-block d-xl-none p-0${isOffcanvasOpen ? ' is-active' : ''}`}
													type="button"
													data-bs-toggle="offcanvas"
													data-bs-target="#offcanvasExample"
													aria-controls="offcanvasExample"
													aria-expanded={isOffcanvasOpen}
													aria-label="Toggle menu"
													onClick={() => setIsOffcanvasOpen((prev) => !prev)}>
													<span className="hamburger-icon">
														<span className="hamburger-line"></span>
														<span className="hamburger-line"></span>
														<span className="hamburger-line"></span>
													</span>
												</button>
											</div>
											<div
												className="collapse navbar-collapse nav-mar-collapse d-none d-xl-flex justify-content-end"
												id="navbarSupportedContent">
												{isXlDevice && renderSearchForm('header-search-form flex-grow-1 mx-4')}
												<form className="d-flex mt-3 mt-lg-0" role="search">
													<NavCtaLinks variant="desktop" />
												</form>
											</div>
										</div>
									</nav>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<NavbarOffcanvasMenu />
		</>
	);
};

export default Navbar;
